import { FC } from 'react';
import Field from 'components/shared/form/presentational/Field';
import Form from 'components/shared/form/presentational/Form';
import TextInput from 'components/shared/form/presentational/TextInput';
import Select from 'components/shared/form/presentational/Select';
import useTranslate from 'lib/languages/useTranslate';
import { validatePhone } from 'lib/utils';
import { internationalCodes } from 'lib/constants';
import { PersonalDetailSection } from 'lib/type';

interface EditContactDetailsProps {
    diallingCode?: string;
    mobile?: string;
    country?: string;
    handleChange: (name: string, value: string) => void;
    handleSubmit: (section: PersonalDetailSection) => Promise<any>;
    isPosting: boolean;
    resetData?: () => void;
}

const EditContactDetails: FC<EditContactDetailsProps> = ({
    handleChange,
    handleSubmit,
    isPosting,
    diallingCode,
    mobile,
    country,
}) => {
    const translate = useTranslate('personalDetails.form');
    const validationTranslate = useTranslate('validation');
    const isSubmitDisabled = !mobile;

    const handleFormSubmit = async () => {
        await handleSubmit(PersonalDetailSection.CONTACT);
    };

    return (
        <Form
            submitText={translate('save')}
            onSubmit={handleFormSubmit}
            isPosting={isPosting}
            tracking
            disabledButton={isSubmitDisabled}
        >
            <Field name={translate('diallingCode')}>
                <Select
                    name="diallingCode"
                    value={diallingCode}
                    onChange={handleChange}
                    placeholder={`${country} (${diallingCode})`}
                    options={internationalCodes}
                    classes="generic-input modal-select"
                />
            </Field>
            <Field name={translate('mobile')}>
                <TextInput
                    name="mobile"
                    placeholder={translate('mobile')}
                    value={mobile}
                    onChange={handleChange}
                    classes="generic-input bg"
                    validate={(value: string) =>
                        validatePhone(
                            value,
                            diallingCode || '',
                            validationTranslate,
                        )
                    }
                />
            </Field>
        </Form>
    );
};

export default EditContactDetails;
